<div class="float-lg-right mb-2 mr-2">
    <button class="btn btn-lg btn-primary" (click)="downloadAsPDF();">{{ "print.makepdf" | translate }}</button>
</div>